import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error('ErrorBoundary caught:', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    minHeight="60vh"
                    gap={2}
                    sx={{ p: 3 }}
                >
                    <ErrorOutlineIcon sx={{ fontSize: 56, color: '#ef4444' }} />
                    <Typography
                        variant="h6"
                        sx={{ fontFamily: '"Outfit", sans-serif', color: '#1e293b', fontWeight: 600 }}
                    >
                        Something went wrong
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: '"Outfit", sans-serif',
                            color: '#64748b',
                            fontSize: '0.875rem',
                            maxWidth: 400,
                            textAlign: 'center',
                        }}
                    >
                        {this.state.error?.message || 'An unexpected error occurred on this page.'}
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.setState({ hasError: false, error: null });
                            window.location.reload();
                        }}
                        sx={{
                            background: '#0f2d5e',
                            '&:hover': { background: '#163571' },
                            fontFamily: '"Outfit", sans-serif',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        Reload page
                    </Button>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
